import React from 'react';
import { FaKey, FaLink, FaShieldAlt, FaTrash } from 'react-icons/fa';

const SETTINGS_ACTIONS = [
  { id: 'password', label: 'Password', detail: 'Change the edit passcode.', icon: FaKey },
  { id: 'giftSet', label: 'NFC Members', detail: 'Manage linked NFC devices.', icon: FaLink },
  { id: 'privacy', label: 'Privacy Policy', detail: 'Review upload and data rules.', icon: FaShieldAlt },
  { id: 'delete', label: 'Delete Gift', detail: 'Remove this gift page.', icon: FaTrash, danger: true },
];

const SettingsStep = ({
  theme,
  onChangePassword,
  onGiftSetSettings,
  onOpenPrivacy,
  onDeleteGift,
}) => {
  const handlers = {
    password: onChangePassword,
    giftSet: onGiftSetSettings,
    privacy: onOpenPrivacy,
    delete: onDeleteGift,
  };

  return (
    <section className="lumirae-editor-panel p-5">
      <div className="text-[10px] font-black uppercase tracking-[0.28em]" style={{ color: theme.accent }}>
        Settings
      </div>
      <h2 className="mt-2 text-2xl font-black tracking-tight" style={{ color: theme.text }}>
        Manage the gift safely
      </h2>
      <p className="mt-2 text-xs font-medium leading-relaxed opacity-60">
        Password, linked NFC members, privacy rules, and destructive actions live here.
      </p>

      <div className="mt-5 grid gap-3">
        {SETTINGS_ACTIONS.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.id}
              type="button"
              className={`lumirae-editor-settings-row ${action.danger ? 'is-danger' : ''}`}
              onClick={handlers[action.id]}
            >
              <span className="lumirae-editor-overview-icon">
                <Icon />
              </span>
              <span className="min-w-0 flex-1 text-left">
                <span className="block text-[10px] font-black uppercase tracking-widest">
                  {action.label}
                </span>
                <span className="mt-1 block text-[10px] font-medium leading-relaxed opacity-55">
                  {action.detail}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default SettingsStep;
